import { getActionState } from '../reducers/requestReducer'
import { RootState } from '../rootReducer'
import { useSelector } from 'react-redux'

export function useReduxSelector<TSelected>(
  selector: (state: RootState) => TSelected,
  equalityFn?: (left: TSelected, right: TSelected) => boolean
) {
  return useSelector<RootState, TSelected>(selector, equalityFn)
}

export function useActionStateSelector(actionName: string) {
  return useReduxSelector(() => getActionState(actionName))
}
